import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Tab, TabsMenu } from "../../ui/tabsMenu/TabsMenu";
import { initDigitalCuratorship } from "../../../store/assessments-actions";
import { deviceTypes } from "../../../enums/deviceTypes";
import DigitalCuratorshipResult from "./digitalCuratorshipResult/DigitalCuratorshipResult";
import DesktopFilters from "../../layout/header/desktopFilters/DesktopFilters";
import MobileFilters from "../../layout/layoutMobile/mobileFilters/MobileFilters";
import classes from "./DigitalCuratorship.module.css";

const DigitalCuratorship = () => {

    const dispatch = useDispatch();
    const { hash } = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [categoriesByData, setCategoriesByData] = useState();
    const [digitalCuratorshipFilterd, setDigitalCuratorshipFilterd] = useState();
    const [filters, setFilters] = useState(null);
    const { texts, lang } = useSelector(state => state.translate);
    const { digitalCuratorship } = useSelector(state => state.assessments);
    const { isStudent } = useSelector(state => state.auth);
    const deviceType = useSelector(state => state.responsive.deviceType);

    useEffect(() => {
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [])

    useEffect(() => {
        if (lang && !digitalCuratorship) {
            dispatch(initDigitalCuratorship());
        }
    }, [dispatch, lang, digitalCuratorship])

    useEffect(() => {
        if (texts && digitalCuratorship?.length) {
            const uniqueCategories = [...new Set(digitalCuratorship.map(x => (isStudent ? x.category : x.tabName)?.trim()))];
            const sortedOrder = window.config.digitalCategorySort
            const uniqueCategoriesSorted = sortedOrder ? uniqueCategories?.sort((a, b) => (sortedOrder[a] || 0) - (sortedOrder[b] || 0)) : uniqueCategories
            setCategoriesByData(uniqueCategoriesSorted.map(uc => ({ name: uc, text: texts[uc] || uc })).sort((a, b) => a.name - b.name));
        }
    }, [texts, digitalCuratorship]);

    useEffect(() => {
        const currentSearch = searchParams.get('tab');
        if (categoriesByData?.length && (!currentSearch || !categoriesByData.find(c => c.name === currentSearch))) {
            setSearchParams({ tab: categoriesByData[0].name });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoriesByData]);

    useEffect(() => {
        let newFilteredCourses = digitalCuratorship;

        if ((filters && Object.keys(filters).length > 0)) {

            Object.entries(filters).forEach(([filterName, filterValues]) => {
                newFilteredCourses = newFilteredCourses?.filter((course) => {
                    const courseValue = course[filterName];

                    if (!Array.isArray(filterValues))
                        filterValues = [filterValues];

                    filterValues = filterValues.flat();

                    if (Array.isArray(courseValue))
                        return filterValues.some((filterValue) => courseValue.includes(filterValue));
                    else
                        return filterValues.includes(courseValue);
                });
            });
            setDigitalCuratorshipFilterd(newFilteredCourses);
        }
        else {
            setDigitalCuratorshipFilterd(digitalCuratorship);
        }

    }, [digitalCuratorship, filters]);

    return (
        <div className={classes.DigitalCuratorship}>
            {!isStudent && (deviceType !== deviceTypes.mobile ? <DesktopFilters setFilters={setFilters} filters={filters} /> : <MobileFilters setFilters={setFilters} filters={filters} />)}
            {categoriesByData ? <TabsMenu
                tabWidth={"max-content"}
                hideTabsTextResp={true}
                dropClassMenu={classes.DropClassMenu}
                downDropStyle={classes.DownDropStyle}
                dropClassTabsMenu={classes.DropClassTabsMenu}
                dropClassScrollLTR={classes.DropClassScrollLTR}
                dropClassScrollContent={classes.DropClassScrollContent}
                startTabIndex={categoriesByData.findIndex(t => t.name === searchParams.get('tab'))}
                tabsName={'DigitalCuratorship'}
                useSearchParams={true}
                accessibilityDescription={texts.curatorship}>
                {categoriesByData.map(categoiry =>
                    <Tab key={categoiry.name} accessibilityDescription={categoiry.text} text={categoiry.text} name={categoiry.name} dropClassTabContent={classes.DropClassTabContent}>
                        {digitalCuratorshipFilterd?.length ? <DigitalCuratorshipResult
                            largeItems={digitalCuratorshipFilterd.filter(x => categoiry.name === (isStudent ? x.category : x.tabName) && x.isBig)}
                            smallItems={digitalCuratorshipFilterd.filter(x => categoiry.name === (isStudent ? x.category : x.tabName) && !x.isBig)} /> : ''}
                    </Tab>
                )}
            </TabsMenu> : ''}
        </div>
    );
};

export default DigitalCuratorship;  
